export default "__VITE_PUBLIC_ASSET__64385e0a__"